/*
 * @Author: Teemo Ding
 * @Date: 2021-10-19 14:14:42
 * @LastEditTime: 2022-06-10 14:02:06
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelMiniProgramSetting/config.tsx
 */
import { Status } from '@/src/types/common/miniProgram';
import React from 'react';
import StatusTag from './Components/StatusTag';
import css from './css.module.less';
import { handleOnFormatCurrentSCTimeAndDateWithTimezone } from 'src/tools/tools';

export const previewColumns = (
  runReview,
  runGenerateQrCode,
  disabled,
  timezoneGmt,
  { getI18n },
) => [
  {
    title: () =>
      getI18n('salesChannelMiniProgramSettings.index.codeVersionNumber'),
    dataIndex: 'version',
    key: 'version',
    width: 192,
    default: true,
  },
  {
    title: () =>
      `${getI18n(
        'salesChannelMiniProgramSettings.index.uploadedDate',
      )} (UTC ${timezoneGmt})`,
    dataIndex: 'submittedDate',
    key: 'submittedDate',
    width: 193,
    default: true,
    render: (text, record) => {
      return handleOnFormatCurrentSCTimeAndDateWithTimezone(text);
    },
  },
  {
    title: () => getI18n('general.remarks'),
    dataIndex: 'remarks',
    key: 'remarks',
    width: 352,
    default: true,
  },
  disabled
    ? {}
    : {
        title: () =>
          getI18n(
            'general.advancedFilters.commonStoreProductsWithTable.actions',
          ),
        key: 'action',
        align: 'center',
        childGenerate: (_, record) => {
          return (
            <div className={css.action}>
              <span onClick={() => runReview(record.uuid)}>
                {getI18n(
                  'salesChannelMiniProgramSettings.index.submitforTencentReview',
                )}
              </span>
              <span onClick={() => runGenerateQrCode(record.uuid)}>
                {getI18n(
                  'salesChannelMiniProgramSettings.index.generateQRCode',
                )}
              </span>
            </div>
          );
        },
        width: 352,
        default: true,
      },
];

export const reviewColumns = (
  runRelease,
  disabled,
  scTimezoneUTC,
  { getI18n },
) => [
  {
    title: () =>
      getI18n('salesChannelMiniProgramSettings.index.codeVersionNumber'),
    dataIndex: 'version',
    key: 'version',
    width: 192,
    default: true,
  },
  {
    title: () =>
      `${getI18n(
        'salesChannelMiniProgramSettings.index.submittedDate',
      )} (UTC ${scTimezoneUTC})`,
    dataIndex: 'submittedDate',
    key: 'submittedDate',
    width: 224,
    default: true,
    render: (text, record) => {
      return handleOnFormatCurrentSCTimeAndDateWithTimezone(text);
    },
  },
  {
    title: () => getI18n('general.status'),
    dataIndex: 'status',
    key: 'status',
    childGenerate: (text: any) => {
      return <StatusTag status={text} />;
    },
    width: 160,
    default: true,
  },
  {
    title: () => getI18n('general.remarks'),
    dataIndex: 'remarks',
    key: 'remarks',
    width: 352,
    default: true,
  },
  disabled
    ? {}
    : {
        title: () =>
          getI18n(
            'general.advancedFilters.commonStoreProductsWithTable.actions',
          ),
        key: 'action',
        align: 'center',
        childGenerate: (_, record) => {
          return (
            <div className={css.action}>
              <span
                className={record.status !== Status.Passed && css.grey}
                onClick={() =>
                  record.status === Status.Passed && runRelease(record.uuid)
                }>
                {getI18n('general.status.release')}
              </span>
            </div>
          );
        },
        width: 160,
        default: true,
      },
];

export const releaseColumns = (timezoneGmt, { getI18n }) => [
  {
    title: () =>
      getI18n('salesChannelMiniProgramSettings.index.codeVersionNumber'),
    dataIndex: 'version',
    key: 'version',
    width: 192,
    default: true,
  },
  {
    title: () =>
      `${getI18n(
        'salesChannelMiniProgramSettings.index.releasedDate',
      )} (UTC ${timezoneGmt})`,
    dataIndex: 'modifiedDate',
    key: 'modifiedDate',
    width: 193,
    default: true,
    render: (text, record) => {
      return handleOnFormatCurrentSCTimeAndDateWithTimezone(text);
    },
  },
  {
    title: () => getI18n('general.status'),
    dataIndex: 'status',
    key: 'status',
    childGenerate: (text: any) => {
      return <StatusTag status={text} />;
    },
    width: 160,
    default: true,
  },
  {
    title: () => getI18n('general.remarks'),
    dataIndex: 'remarks',
    key: 'remarks',
    width: 352,
    default: true,
  },
];
